export enum ELandingPagesTabs {
    Organic = 0,
    Paid = 1,
}

export interface IDataRecord {
    Clicks: number;
    ClicksChange: number;
    ClicksShare: number;
    DesktopClicks: number;
    KeywordsCount: number;
    LatestKeywordSerpDate: string;
    Position: number;
    PositionOverall: number;
    PrevClicks: number;
    PrevPosition: number;
    PrevPositionOverall: number;
    RecordsCount: number;
    SerpFeatures: string[];
    TopKeyword: string;
    Url: string;
    Trend: Record<string, number>;
    Volume: number;
    AverageVolume: number;
    UrlSpend: number;
    AdsCount: number;
}

export interface IData {
    Data: IDataRecord[];
}

export const sourceTypeMap: Record<keyof typeof ELandingPagesTabs, string> = {
    Organic: "organic",
    Paid: "paid",
};
